import Main from './Main'
import Lista from './components/CadastrosPublicosLista'
import Novo from './components/NovoCadastroPublico'

export default [
  {
    path: 'cadastro-publico',
    name: 'config.cadastro-publico',
    component: Main,
    redirect: { name: 'config.cadastro-publico.list' },
    children: [
      {
        path: '/',
        name: 'config.cadastro-publico.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.cadastro-publico.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.cadastro-publico.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/cadastro-publico/routes.js